import DynamicIcon from "./dynamic-icon";

const NavNewPageItem = ({ onClick, icon, children, isOpen }) => {
    return (
        <div onClick={onClick} className="flex flex-shrink-0 custom-text-grey-800 justify-between items-center w-full text-[12px] h-[35px] px-[27px] lg:rounded-[8px] cursor-pointer">
            <div className="flex justify-start items-center  gap-[12px]">
                {icon && (
                    <DynamicIcon name={icon} size="16" color="currentColor" />
                )}
                <span
                    className="custom-text-grey-500  poppins-medium text-[12px] tracking-[0.5px] truncate whitespace nowrap">
                    {children}
                </span>
            </div>
        </div>
    );
};

export default NavNewPageItem;